import React, { Component } from 'react';
import { heroImages, DESKTOP_IMAGE, MOBILE_IMAGE } from '../config';
import './style.scss';

class HeroImages extends Component {
    constructor(props) {
        super(props);

        this.state = {
            backgroundIndex: 0
        };

        this.changeBackground = this.changeBackground.bind(this);
    }

    componentDidMount(){
        this.interval = setInterval(
            this.changeBackground,
            4500
        );
    }

    componentWillUnmount(){
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    changeBackground() {
        const { backgroundIndex } = this.state;
        const nextBackgroundIndex = (backgroundIndex + 1) % heroImages.length;

        this.setState({
            backgroundIndex: nextBackgroundIndex
        });
    }

    render() {
        const { backgroundIndex } = this.state;

        return (
            <div className="hero-images">
                {
                    heroImages.map((heroImage, index) => {
                        const style = {opacity: index === backgroundIndex ? '1': '0'};

                        // For mobile images we load 1px base64 image because otherwise the fallback <img> src will be loaded

                        return (
                            <figure key={index}>
                                <picture>
                                    <source media={MOBILE_IMAGE} sizes="1px"
                                        srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 1w"/>
                                    <source media={DESKTOP_IMAGE} srcSet={heroImage.desktop}/>
                                    <img src={heroImage.src} style={style} alt={heroImage.title}/>
                                </picture>
                                <figcaption style={style}>
                                    <div className="seller-wrapper">
                                        {heroImage.name}, <b>{heroImage.title}</b>
                                    </div>
                                </figcaption>
                            </figure>
                        );
                    })
                }
            </div>
        );
    }

}

export default HeroImages;
